import { render, staticRenderFns } from "./Dormitory.vue?vue&type=template&id=f255810a&scoped=true"
import script from "./Dormitory.vue?vue&type=script&lang=js"
export * from "./Dormitory.vue?vue&type=script&lang=js"
import style0 from "./Dormitory.vue?vue&type=style&index=0&id=f255810a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f255810a",
  null
  
)

export default component.exports